import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyEmail } from "../../store";
import { useThunk } from "../../hooks/useThunk";
import { useEffect, useState } from "react";

import ButtonSpinner from "../../components/loading/ButtonSpinner";
import blueBg from "../../assets/Login/bluebg.svg";
import loginImage from "../../assets/Login/image1.png";
import LoginImageMobile from "../../assets/Login/mobilebg.svg";
import LoginImageTab from "../../assets/Login/bluebg-tabs.png";
import LoginButton from "../../components/Form/LoginButton";

export const VerifyEmail = () => {
  const [searchParams, setSearchParam] = useSearchParams();
  const navigate = useNavigate();

  const [doVerify, isVerifying, verifyError] = useThunk(verifyEmail);
  const [responseMessage, setResponseMessage] = useState();

  const token = searchParams.get("token");
  const id = searchParams.get("id");

  useEffect(() => {
    if (!token || !id) {
      setResponseMessage(
        "We Can't Verify Your Email. Invalid Verification link"
      );
    }

    doVerify({ token, id }).then((result) => {
      if (result.success) {
        setResponseMessage(result.response.message);
      } else {
        setResponseMessage(result.error.message);
      }
    });
  }, []);

  return (
    <div>
      <div className="flex flex-col min-w-[403px] relative w-full h-screen overflow-x-hidden">
        {/* WatermarkBg*/}
        <div className="lg:hidden absolute right-0 w-[60%]">
          <img
            src={LoginImageMobile}
            alt="background"
            className="sm:hidden w-full"
          />
          <img
            src={LoginImageTab}
            alt="background"
            className="hidden sm:block ml-[40px] w-full"
          />
        </div>

        <div className="absolute z-0 top-0 right-0 w-full login-br:block">
          <img
            src={blueBg}
            alt="background"
            className="hidden lg:block absolute -right-15 -top-20 lg:right-0 w-full  lg:max-w-[650px] xl:max-w-[700px] 2xl:max-w-[750px] 1920-br:max-w-[850px] 2560-br:max-w-[1400px] transition-all duration-300"
          />
        </div>

        {/* Form Container-left  */}
        <div className="relative z-10 mx-auto mt-16 pb-10 flex flex-grow items-start sm:items-center justify-center login-br:justify-between w-full 2xl:max-w-[1536px] auth-layout-structure-in-tab-screen-higher-than-880-height">
          <div className="w-full lg:w-[90%] 2xl:w-[60%] flex flex-col justify-center px-10 lg:px-20 ml-0 1920-br:translate-x-[80px]">
            <h1 className="sm:block hidden text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2">
              Email Verification{" "}
            </h1>

            <h1 className=" sm:hidden block text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2">
              Email{" "}
            </h1>
            <h1 className=" sm:hidden block text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2">
              Verification{" "}
            </h1>

            <p className="mb-0 font-inter text-[18px] text-gray max-w-[200px] sm:max-w-[300px] md:max-w-none">
              Congratulations! Your <span> {responseMessage}. </span>
            </p>
            <p className="font-inter text-[18px] text-gray max-w-[200px] sm:max-w-[300px] md:max-w-[400px]">
              Sign In to start using your account. Click the button below to
              sign in to your account.
            </p>

            <form className="w-full sm:max-lg:w-[50%] max-sm:mt-20 mt-[160px]">
              <div className="flex flex-col items-start justify-start ">
                {/* Sign-Up Button */}
                {
                  responseMessage &&
                  <LoginButton
                    text="Sign In"
                    type="submit"
                    className="max-w-[480px] py-3 h-[54px]"
                    onClick={() => {navigate("/signin")}}
                  />
                }
              </div>
            </form>
          </div>
          {/* Right Side: Image */}
          <div className="hidden lg:flex items-center justify-center w-full md:max-w-[480px] lg:max-w-[580px] xl:max-w-[650px] max-1440-br:-translate-y-32 1920-br:-translate-x-[80px]">
            <img src={loginImage} alt="Sign Up" />
          </div>
        </div>
      </div>
      <h1></h1>
      <h1></h1>
      <h1></h1>
      <h1></h1>
      <h1></h1>
    </div>
  );
};
